import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { UntypedFormArray, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { SourceChannel, ChannelList, PublicationList, PublicationSave } from '../../models/publicationmodel';
import { PublicationService } from '../../services/publication.service';
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from '../../../shared/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-publication',
  templateUrl: './publication.component.html',
  styleUrls: ['./publication.component.scss'],
  standalone: false,
})
export class PublicationComponent implements OnInit, OnChanges {
  dataSource = new MatTableDataSource<PublicationList>([]);
  displayedColumns: string[] = [
    'sourceName',
    'refrenceCode',
    'startDate',
    'endDate',
    'hotJob',
    'hotJobDays',
    'status',
    'Edit/Delete',
    'Add',
  ];
  controls: UntypedFormArray;
  list: PublicationList[];
  tableData = { data: [] };
  channelList: SourceChannel;
  allChannelList: SourceChannel;
  channel: ChannelList[];
  secondaryChannel: ChannelList[];
  editDisable = false;
  startDate: Date = new Date();
  endDate: Date;
  minDate: Date = new Date();
  hotJobVal: boolean = false;
  afterEdit: boolean = true;
  quar: string;
  quarYear;
  data: PublicationSave = <PublicationSave>{};
  @Input() postingId: number;
  @Input() typeId: number;
  @Input() viemMode: boolean = false;
  @Input() errorMessageId: boolean;
  @Input() cancel: boolean;
  @Input() reqId: any;
  // @Input() reloadData: boolean;
  @Output() publishButton = new EventEmitter();
  get value() {
    this.data.publicationList = this.dataSource.data;
    return this.data;
  }

  get validate() {
    if (this.list && this.list.length > 0) {
      this.controls.controls.forEach((element, index) => {
        if (!this.getControl(index, 'startDate').valid) {
          this.getControl(index, 'startDate').markAsTouched();
        }
        if (!this.getControl(index, 'endDate').valid) {
          this.getControl(index, 'endDate').markAsTouched();
        }
        if (!this.getControl(index, 'hotJobDays').valid) {
          this.getControl(index, 'hotJobDays').markAsTouched();
        }
        return false;
      });
      return true;
    } else {
      return false;
    }
  }
  constructor(
    private datePipe: DatePipe,
    private dataService: PublicationService,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    // this.dataService.getRequisitionData(this.reqId).subscribe((req) => {
    //   this.setReqYear(req.requisitionYear);
    //   if (req.companyHiringTypeId == 1) {
    //     if (req.quarter == "Q1") {
    //       this.quar = "Q1";
    //     }
    //     else if (req.quarter == "Q2") {
    //       this.quar = "Q2";
    //     }
    //     else if (req.quarter == "Q3") {
    //       this.quar = "Q3";
    //     }
    //     else {
    //       this.quar = "Q4";
    //     }
    //   }

    // })

    this.dataService.getSourceChannel(this.typeId).subscribe((value) => {
      this.channelList = value;
      this.channel = this.channelList.channelList.filter((ele) => {
        let flag = true;
        for (const chan of this.list) {
          if (ele.sourceName == chan.sourceName && chan.status != 'Withdrawn') {
            flag = false;
          }
        }
        if (flag) {
          return ele;
        }
      });
    });
    console.log('this.channel', this.channel, this.channelList);

    if (this.postingId != -1 || this.cancel) {
      this.loadTableDataAfterUpdate();
    } else {
      this.loadTableData();
    }
  }

  loadTableData() {
    this.list = [];
    // this.dataService.getpublicationList(this.postingId, this.typeId).subscribe(value => {
    //   this.list = value;

    //   // this.eleName = (this.list && this.list.length > 0) ? this.list[0].sourceName: '';
    //   // console.log(this.eleName);

    this.list.forEach((data) => {
      data['isEditable'] = true;
      data.startDate = new Date();
      data.endDate = new Date();
    });

    this.dataSource.data = this.list;
    //   // this.setDateData(true);
    this.buildtableData();
    //   //  this.buildFormarray();
    // });
  }

  ngOnChanges() {
    // this.loadTableData();
    // this.loadTableDataAfterUpdate()
    // if (this.reloadData) {
    if (this.postingId != -1 || this.cancel) {
      this.loadTableDataAfterUpdate();
    } else {
      this.loadTableData();
    }
    // }
  }
  loadTableDataAfterUpdate() {
    this.list = [];
    // this.dataService.getpublicationList(this.postingId, this.typeId).subscribe(value => {
    //   this.list = value;
    //   if (this.postingId != -1) {
    this.list.forEach((data) => {
      data['isEditable'] = false;
      // data.startDate = data.startDate;
      // data.endDate = data.endDate;
    });

    //     // this.list.forEach((x,index) => {
    //     //   if(x.parentSourceId !== 0){
    //     //     const val = this.list.findIndex(res => res.sourceId === x.parentSourceId);
    //     //     if(val === -1){
    //     //     this.list.splice(index, 0, {
    //     //       sourceId: x.parentSourceId,
    //     //       sourceName : this.channelList.channelList.find(res=> res.sourceId === x.parentSourceId).sourceName
    //     //     })
    //     // this.list.splice(index, 0, {
    //     //   sourceId: x.parentSourceId,
    //     //   sourceName : this.channelList.channelList.find(ress=> ress.sourceId === x.parentSourceId).sourceName
    //     // })
    //     // }
    //     // }
    //     // if(x.parentSourceId !== 0){
    //     //   const val = this.list.findIndex(res => res.sourceId === x.parentSourceId);
    //     //   if(val === -1){
    //     //   this.list.splice(index, 0, {
    //     //     sourceId: x.parentSourceId,
    //     //     sourceName : this.channelList.channelList.find(res=> res.sourceId === x.parentSourceId).sourceName
    //     //   })
    //     // }
    //     // }
    //     // })
    this.dataSource.data = this.list;
    //     // this.setDateData(true);
    this.buildtableData();
    this.buildFormarray();
    this.enableEdit();
    //   }
    //   //  this.dataSource.data = this.list;
    //   //  this.buildFormarray();
    //   // this.dataSource.data = this.list;
    //   // this.startDate = new Date();
    //   // this.endDate = new Date();
    //   // this.buildtableData();
    //   // this.buildFormarray();
    // });
  }
  orgValueChange(date) {
    // console.log(date.value.getDate());
    this.minDate.setDate(date.value.getDate() + 1);
    // this.setDateData(false);
  }

  buildtableData() {
    this.tableData.data = JSON.parse(JSON.stringify(this.list));
    this.dataSource.data = this.tableData.data;
    this.list = this.tableData.data;
  }

  getControl(index, fieldName) {
    // const a = this.controls.at(index).get(fieldName) as FormControl;
    return this.controls.at(index).get(fieldName) as UntypedFormControl;
  }

  update1(rowId: number, data: any) {
    if (data.sourceId) {
      if (this.controls.value[rowId].hotJob && this.controls.value[rowId].hotJobDays > 0) {
        this.channel.forEach((channelData) => {
          if (channelData.sourceName == this.controls.value[rowId].sourceName) {
            this.list[rowId].sourceId = channelData.sourceId;
          }
        });
        this.list[rowId].sourceName = this.controls.value[rowId].sourceName;
        this.list[rowId].startDate = this.datePipe.transform(this.controls.value[rowId].startDate, 'dd-MMM-yyyy');
        this.list[rowId].endDate = this.datePipe.transform(this.controls.value[rowId].endDate, 'dd-MMM-yyyy');
        this.list[rowId].hotJob = this.controls.value[rowId].hotJob;
        this.list[rowId].hotJobDays = this.controls.value[rowId].hotJobDays;
        this.dataSource.data = this.list;
        data.isEditable = false;
        this.enableEdit();
        this.publishButton.emit(false);
      } else {
        if (!this.controls.value[rowId].hotJob) {
          this.channel.forEach((channelData) => {
            if (channelData.sourceName == this.controls.value[rowId].sourceName) {
              this.list[rowId].sourceId = channelData.sourceId;
            }
          });
          this.list[rowId].sourceName = this.controls.value[rowId].sourceName;
          this.list[rowId].startDate = this.datePipe.transform(this.controls.value[rowId].startDate, 'dd-MMM-yyyy');
          this.list[rowId].endDate = this.datePipe.transform(this.controls.value[rowId].endDate, 'dd-MMM-yyyy');
          this.list[rowId].hotJob = false;
          this.list[rowId].hotJobDays = null;
          this.dataSource.data = this.list;
          data.isEditable = false;
          this.enableEdit();
          this.publishButton.emit(false);
        } else {
          this.getControl(rowId, 'hotJobDays').markAsTouched();
        }
      }
    } else {
      if (
        this.controls.value[rowId].sourceName &&
        (this.controls.value[rowId].startDate && this.controls.value[rowId].endDate) != 'Invalid Date'
      ) {
        if (this.controls.value[rowId].endDate >= this.controls.value[rowId].startDate) {
          if (this.controls.value[rowId].hotJob && this.controls.value[rowId].hotJobDays > 0) {
            this.channel.forEach((channelData) => {
              if (channelData.sourceName == this.controls.value[rowId].sourceName) {
                this.list[rowId].sourceId = channelData.sourceId;
              }
            });
            this.list[rowId].sourceName = this.controls.value[rowId].sourceName;
            this.list[rowId].startDate = this.datePipe.transform(this.controls.value[rowId].startDate, 'dd-MMM-yyyy');
            this.list[rowId].endDate = this.datePipe.transform(this.controls.value[rowId].endDate, 'dd-MMM-yyyy');
            this.list[rowId].hotJob = this.controls.value[rowId].hotJob;
            this.list[rowId].hotJobDays = this.controls.value[rowId].hotJobDays;
            this.dataSource.data = this.list;
            data.isEditable = false;
            this.enableEdit();
            this.publishButton.emit(false);
            this.errorMessageId = false;
          } else {
            if (!this.controls.value[rowId].hotJob) {
              this.channel.forEach((channelData) => {
                if (channelData.sourceName == this.controls.value[rowId].sourceName) {
                  this.list[rowId].sourceId = channelData.sourceId;
                }
              });
              this.list[rowId].sourceName = this.controls.value[rowId].sourceName;
              this.list[rowId].startDate = this.datePipe.transform(this.controls.value[rowId].startDate, 'dd-MMM-yyyy');
              this.list[rowId].endDate = this.datePipe.transform(this.controls.value[rowId].endDate, 'dd-MMM-yyyy');
              this.list[rowId].hotJob = false;
              this.list[rowId].hotJobDays = null;
              this.dataSource.data = this.list;
              data.isEditable = false;
              this.enableEdit();
              this.dataSource.data = this.list;
              data.isEditable = false;
              this.enableEdit();
              this.errorMessageId = false;
              this.publishButton.emit(false);
            } else {
              this.getControl(rowId, 'hotJobDays').markAsTouched();
            }
          }
        }
      } else {
        if (!this.controls.value[rowId].sourceName) {
          this.getControl(rowId, 'sourceName').markAsTouched();
        }
        if (this.controls.value[rowId].startDate == 'Invalid Date') {
          this.getControl(rowId, 'startDate').markAsTouched();
        }
        if (this.controls.value[rowId].endDate == 'Invalid Date') {
          this.getControl(rowId, 'endDate').markAsTouched();
        }
      }
    }
  }

  // setReqYear(year) {
  //   this.quarYear = year;
  // }

  // setDateData(setMin: boolean) {
  //   let currentDate = new Date();
  //   if (this.quar) {
  //     let val = this.quarYear;
  //     if (this.quar == "Q1") {
  //       this.startDate = new Date(val, 3, 1);
  //       this.endDate = new Date(val, 5, 30);
  //     }
  //     else if (this.quar == "Q2") {
  //       this.startDate = new Date(val, 6, 1);
  //       this.endDate = new Date(val, 8, 30);
  //     }
  //     else if (this.quar == "Q3") {
  //       this.startDate = new Date(val, 9, 1);
  //       this.endDate = new Date(val, 11, 31);
  //     }
  //     else {
  //       let val1 = val + 1;
  //       this.startDate = new Date(val1, 0, 1);
  //       this.endDate = new Date(val1, 2, 31);
  //     }
  //     if (currentDate > this.startDate) {
  //       this.startDate = currentDate;
  //     }
  //   }
  //   else {
  //     if (this.quarYear < currentDate.getFullYear()) {
  //       this.startDate = new Date(currentDate.getFullYear(), 0, 1);
  //       this.endDate = new Date(currentDate.getFullYear(), 11, 31);
  //     }
  //     else if (this.quarYear == currentDate.getFullYear()) {
  //       this.startDate = new Date(currentDate.getFullYear(), 3, 1);
  //       this.endDate = new Date(currentDate.getFullYear() + 1, 2, 31);
  //     }
  //     else {
  //       let newYear = parseInt(this.quarYear) + 1;
  //       this.startDate = new Date(this.quarYear, 3, 1);
  //       this.endDate = new Date(newYear, 2, 31);
  //     }
  //     if (currentDate > this.startDate) {
  //       this.startDate = currentDate;
  //     }
  //   }
  //   if (setMin) {
  //     this.minDate = this.startDate;
  //   }
  // }

  closeUpdate(rowId, data) {
    if (data.sourceId == null || data.sourceId == 0) {
      data.isEditable = false;
      this.enableEdit();
      this.controls.controls.splice(rowId, 1);
      this.controls.value.splice(rowId, 1);
      this.list.splice(rowId, 1);
      this.dataSource.data = this.list;
    } else {
      this.list[rowId].startDate = this.datePipe.transform(this.list[rowId].startDate, 'dd-MMM-yyyy');
      this.list[rowId].endDate = this.datePipe.transform(this.list[rowId].endDate, 'dd-MMM-yyyy');
      this.dataSource.data = this.list;
      data.isEditable = false;
      this.enableEdit();
    }
    this.publishButton.emit(false);
  }

  edit(rowId: number, data: any) {
    this.publishButton.emit(true);
    data.isEditable = true;
    let dropdownFlag: boolean = true;
    if (data.referenceCode) {
      this.afterEdit = false;
      const temp = new Date(data.startDate);
      this.minDate = new Date(temp.getFullYear(), temp.getMonth(), temp.getDate() + 1);
    } else {
      this.afterEdit = true;
      this.list[rowId].startDate = new Date(this.controls.value[rowId].startDate);
    }
    if (data.sourceId) {
      this.hotJobVal = data.hotJob;
      for (const chan of this.channelList.channelList) {
        if (chan.sourceName == data.sourceName) {
          dropdownFlag = false;
          break;
        }
      }
      if (dropdownFlag) {
        this.dataService.getSecondarySourceList(data.parentSourceId).subscribe((value) => {
          this.secondaryChannel = value;
          const temp = this.list.filter((ele) => {
            return ele.sourceName != data.sourceName;
          });
          this.channel = this.secondaryChannel.filter((ele) => {
            let flag = true;
            for (const chan of temp) {
              if (ele.sourceName == chan.sourceName && chan.status != 'Withdrawn') {
                flag = false;
                break;
              }
            }
            if (flag) {
              return ele;
            }
          });
        });
      } else {
        const temp = this.list.filter((ele) => {
          return ele.sourceName != data.sourceName;
        });
        this.channel = this.channelList.channelList.filter((ele) => {
          let flag = true;
          for (const chan of temp) {
            if (ele.sourceName == chan.sourceName && chan.status != 'Withdrawn') {
              flag = false;
              break;
            }
          }
          if (flag) {
            return ele;
          }
        });
      }
    }
    this.hotJobVal = false;
    this.list[rowId].endDate = new Date(this.controls.value[rowId].endDate);
    this.dataSource.data = this.list;
    this.buildFormarray();
    this.disableEdit();
  }

  disableEdit() {
    this.editDisable = true;
  }

  enableEdit() {
    this.editDisable = false;
  }

  deleteRow(rowId) {
    if (this.list[rowId].referenceCode) {
      const message = 'Are you sure you want to delete ' + this.list[rowId].sourceName + ' ?';
      const dialogData = new ConfirmDialogModel(message, '');
      const dialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
      dialogRef.afterClosed().subscribe((dialogResult) => {
        if (dialogResult) {
          this.list[rowId].status = 'Withdrawn';
        }
      });
    } else {
      if (this.list.length == 1) {
        this.errorMessageId = true;
      }
      this.list.splice(rowId, 1);
    }
    this.dataSource.data = this.list;
  }

  channelSelect(value, index) {
    this.dataService.getSourceChannel(this.typeId).subscribe((res) => {
      this.allChannelList = res;
      const allChannel = this.allChannelList.channelList;
      if (value.value == 'Job Sites' || value.value == 'Vendor') {
        const sourceId = allChannel.find((channelRes) => channelRes.sourceName === value.value).sourceId;
        value.sourceId = sourceId;
      }
      this.update2(index, value);
    });
  }
  update2(rowId: number, data: any) {
    console.log(data);
    console.log(this.controls.value[rowId]);

    let flag: boolean = true;
    let srcId = null;

    for (const chan of this.channelList.channelList) {
      if (this.controls.value[rowId].sourceName === chan.sourceName && chan.isSecondary === 'Y') {
        srcId = chan.sourceId;
        flag = false;
      }
    }

    if (!flag) {
      this.list.splice(rowId, 1);
      this.tableData.data.push({ sourceId: srcId, sourceName: this.controls.value[rowId].sourceName });
      this.list = this.tableData.data;
      this.enableEdit();
      this.publishButton.emit(false);
    }

    this.dataSource.data = this.list;
    data.isEditable = false;
    // this.enableEdit();
  }
  // addSecondarySourceRow(index, sourceName) {
  //   this.list.splice(index, 0, { sourceName: sourceName });
  //   this.list.splice(index + 1, 1, {
  //     publicationId: "", sourceId: null, sourceType: "", sourceName: "", "isSecondary": false,
  //     refrenceCode: "", startDate: "", endDate: "", status: "", hotJob: false, hotJobDays: "", isEditable: true
  //   });
  //   this.buildFormarray();
  //   this.dataSource.data = this.list;
  // }

  addTableRow() {
    if (this.errorMessageId) {
      this.enableEdit();
      this.list = [];
      this.dataSource.data = this.list;
    }
    if (!this.editDisable) {
      this.channel = this.channelList.channelList.filter((ele) => {
        let flag = true;
        for (const chan of this.list) {
          if (ele.sourceName == chan.sourceName && chan.status != 'Withdrawn') {
            flag = false;
            break;
          }
        }
        if (flag) {
          return ele;
        }
      });
      this.list.push({
        publicationId: -1,
        sourceId: null,
        sourceName: '',
        referenceCode: '',
        startDate: '',
        endDate: '',
        status: '',
        hotJob: false,
        hotJobDays: null,
      });
      this.buildFormarray();
      this.dataSource.data = this.list;
      this.edit(this.list.length - 1, this.list[this.list.length - 1]);
    }
    this.disableEdit();
  }

  buildFormarray() {
    const toGroups = this.list.map((entity) => {
      return new UntypedFormGroup(
        {
          sourceName: new UntypedFormControl(entity.sourceName, Validators.required),
          refrenceCode: new UntypedFormControl(entity.referenceCode, Validators.required),
          startDate: new UntypedFormControl(entity.startDate, Validators.required),
          endDate: new UntypedFormControl(entity.endDate, Validators.required),
          hotJob: new UntypedFormControl(entity.hotJob, Validators.required),
          hotJobDays: new UntypedFormControl(entity.hotJobDays, Validators.required),
          status: new UntypedFormControl(entity.status, Validators.required),
        },
        { updateOn: 'blur' },
      );
    });

    this.controls = new UntypedFormArray(toGroups);
  }

  addSecondarySource(value, element) {
    if (!this.editDisable) {
      this.dataService.getSecondarySourceList(element.sourceId).subscribe((listValue) => {
        this.secondaryChannel = listValue;
        this.channel = this.secondaryChannel.filter((ele) => {
          let flag = true;
          for (const chan of this.list) {
            if (ele.sourceName == chan.sourceName && chan.status != 'Withdrawn') {
              flag = false;
              break;
            }
          }
          if (flag) {
            return ele;
          }
        });
      });
      const index = this.list.map((val) => val.sourceName === this.list[value].sourceName).lastIndexOf(true);
      this.list.splice(index + 1, 0, {
        publicationId: -1,
        sourceId: null,
        sourceName: '',
        referenceCode: '',
        startDate: '',
        endDate: '',
        status: '',
        hotJob: false,
        hotJobDays: null,
        parentSourceId: element.sourceId,
      });
      this.buildFormarray();
      this.dataSource.data = this.list;
      this.edit(index + 1, this.list[index + 1]);
    }
    this.disableEdit();
  }

  hotJobCheck(index) {
    if (this.hotJobVal && !this.getControl(index, 'hotJobDays').value) {
      this.getControl(index, 'hotJobDays').markAsTouched();
    } else {
      this.getControl(index, 'hotJobDays').markAsUntouched();
    }
  }
}
